import getExtensibilityState from '../store/getExtensibilityState';
import { ActiveDialog } from '../store/schema/interfaces/Dialog';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setActiveDialog', function setActiveDialog(
    activeDialog: ActiveDialog
) {
    getExtensibilityState().activeDialog = activeDialog;
});
